module.exports = __webpack_public_path__ + "static/media/A1-16-Kalberus-cod98.0ee6b026.png";